import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    html {
        scroll-behavior: smooth;
    }

    html.normal-scroll {
        scroll-behavior: auto;
    }

    *,
    *::after,
    *::before {
        box-sizing: border-box;
    }

    body {
        margin: 0;
        padding: 0;
        background: #fff;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";

    }

    a {
        text-decoration: inherit;
        color: inherit;
        cursor: pointer;
        @media (max-width: 720px) {
            cursor: auto;
        }
    }

    a:visited {
        text-decoration: inherit;
        color: inherit;
        cursor: pointer;
        @media (max-width: 720px) {
            cursor: auto;
        }
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    ol {
        margin: 0;
        padding: 0;
    }

    h1, h2, h3, h4, h5, h6, p {
        margin: 0;
    }

    a {
        text-decoration: none;
    }


    #productId {
        border-collapse: collapse;
        width: 80%;
        margin-top: 30px;
    }

    #productId td, #productId th {
        border: 1px solid #ddd;
        padding: 8px;
    }

    #productId thead:nth-child(even) {
        background-color: #f2f2f2;
    }

    #productId th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #f2f2f2
    }





`;

export default GlobalStyle;

export const DesktopAndMobileDivWrapper = styled.div`
  @media (min-width: 720px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: ${(props) =>
      props.maxWidth ? `${props.maxWidth}px` : '1050px'};
    margin: 0px auto;
  }
`;
